import React from "react";
import "./C2Page.css";

const C2CourseDetails = () => {
  return (
    <div className="c2DetailsContainer">
      <ol>
        <li>Proficiency increases as you speak with native speaker</li>
        <li>Able to discuss about political and scientific research</li>
        <li>
          Will be able to understand at any pace if a native speaker speaks
        </li>
        <li>
          Every point in this level is completely based from A1 to C1 Level of
          the language
        </li>
      </ol>
      <p>
        In the C2 German courses in Bangalore you will understand practically
        everything you read or hear without any problems. You can summarize
        information from different sources and present justifications and
        explanations uniformly. You can express yourself promptly, very fluently
        and precisely and be able to clarify subtle nuances within complex
        topics.
      </p>
      <h3>Main topics:</h3>
      <ul>
        <li>Communication and media</li>
        <li>History and memories</li>
        <li>Feelings, lies, strengths and weaknesses</li>
        <li>School time</li>
        <li>Career opportunities and professions</li>
      </ul>
      <h3>Grammar:</h3>
      <ul>
        <li>Tenses of the verbs</li>
        <li>Verbs with prefixes, which may or may not be separable</li>
        <li>Subjunctive II</li>
        <li>Subjunctive I</li>
        <li>Adverbial clauses</li>
        <li>Verbs and their complements</li>
        <li>Noun connectors</li>
        <li>Word formation of the nouns</li>
        <li>Participles as adjectives</li>
        <li>Nominalized adjectives and participles</li>
        <li>Relative clauses</li>
      </ul>
    </div>
  );
};

export default C2CourseDetails;
